import { render, staticRenderFns } from "./ForSale.vue?vue&type=template&id=2de8d6c1&scoped=true&"
import script from "./ForSale.vue?vue&type=script&lang=js&"
export * from "./ForSale.vue?vue&type=script&lang=js&"
import style0 from "./ForSale.vue?vue&type=style&index=0&id=2de8d6c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de8d6c1",
  null
  
)

export default component.exports